'use strict';

angular.module('TurneroApp').component('coRecepcion', {
    controller: [
        '$scope',
        '$rootScope',
        '$interval',
        '$timeout',
        'utilsService',
        'signalrDotNetCoreService',
        'TurneroAppConstant',
        'generalService',
        function ($scope, $rootScope, $interval, $timeout, utilsService, signalrServiceExterno, TurneroAppConstant, generalService) {
            var ctrl = this;
            ctrl.sinConexion = false;
            ctrl.sinConexionTimer = null;

            ctrl.cambiarCentroDeAtencion = function (centroAtencionSeleccionado) {
                ctrl.centroAtencion = centroAtencionSeleccionado;
            };

            ctrl.redirect = function (redirect) {
                ctrl.redirect = redirect;
            };

            window.addEventListener('touchstart', function () {
                // the user touched the screen!
                ctrl.StopTimer();
            });

            $scope.$watch(function () {
                return document.body.innerHTML;
            }, function (val) {
                ctrl.StopTimer();
            });

            ctrl.StarTimer = function () {
                //Creo el timer para que cada cierto tiempo vuelva a la pantalla de inicio.
                ctrl.Timer = $interval(function () {
                    //pone todas las pantallas en false.
                    ctrl.limpiarVariables();
                    //redirije a home de recepcion
                    ctrl.mostrar.Home = true;
                    //cierro todos los modales abiertos
                    swal.close();
                    $rootScope.$broadcast('limpiarRecepcion', true);
                }, 20000);
            };

            //Timer stop function.
            ctrl.StopTimer = function () {
                //Cancel the Timer.
                if (angular.isDefined(ctrl.Timer)) {
                    $interval.cancel(ctrl.Timer);
                }
                ctrl.StarTimer();

            };

            ctrl.mostrar = {
                Home: true,
                DNIAnunciar: false,
                DNISacar: false,
                Anunciar: false,
                Sacar: false
            };

            ctrl.limpiarVariables = function () {
                ctrl.mostrar = {
                    Home: false,
                    DNIAnunciar: false,
                    DNISacar: false,
                    Anunciar: false,
                    Sacar: false
                }
            }

            $scope.$on('sacarTurno', function (event, bool) {
                ctrl.limpiarVariables();
                ctrl.mostrar.DNISacar = bool
            });

            $scope.$on('anunciarTurno', function (event, bool) {
                ctrl.limpiarVariables();
                ctrl.mostrar.DNIAnunciar = bool;
                $rootScope.$broadcast('limpiarRecepcion', true);
            });

            $scope.$on('GoHome', function (event, bool) {
                ctrl.limpiarVariables();
                ctrl.mostrar.Home = bool
            });

            $scope.$on('MostrarTurnosAnunciar', function (event, personaSeleccionada) {
                ctrl.limpiarVariables();
                ctrl.mostrar.Anunciar = true;
                $rootScope.$broadcast('PersonaSeleccionada', personaSeleccionada);
            });

            //CiudadanoSeleccionado
            $scope.$on('CiudadanoSeleccionado', function (event, personaSeleccionada) {
                ctrl.limpiarVariables();
                ctrl.mostrar.Sacar = true;
                ctrl.Persona = personaSeleccionada;
            });

            $scope.$on('resetTimer', function (event, bool) {
                ctrl.StopTimer();
            });
            
            ctrl.getVersion = function () {
                generalService.Get_Version().$promise.then(function (resultado) {
                    if (resultado) {
                        ctrl.version = resultado.Version;
                        ctrl.entorno = resultado.Entorno;
                    }
                }) 
            }
            ctrl.getVersion();

            ctrl.getServer = function () {

                generalService.Get_Server_Id().$promise.then(function (resultado) {
                    ctrl.server = resultado.Data;
                }).catch(function (error) {

                })
            }
            ctrl.getServer();

            //cuando se llama a una conexión
            $scope.$on('BeforeHubConnectionStart', function (event, hub) {
                //si es la primera vez que se conecta o ya estaba conectado entonces doy por hecho que no se conectó hasta que reciba el AfterHubConnectionStart
                if (!ctrl.sinConexion) {
                    //le doy unos segundos antes de mostrar la alerta
                    if (!ctrl.sinConexionTimer)
                        ctrl.sinConexionTimer = $timeout(function () { ctrl.sinConexion = true }, 3000);
                }
            });

            //cuando se conecta al hub oculto el toast
            $scope.$on('AfterHubConnectionStart', function (event, hub) {
                if (ctrl.sinConexionTimer)
                    $timeout.cancel(ctrl.sinConexionTimer);

                ctrl.sinConexion = false;
            });

            //cuando se desconecta el hub muestro el toast
            $scope.$on('AfterHubConnectionClose', function (event, hub) {
                ctrl.sinConexion = true;
            });
        }],
    template: require('./recepcion.html')
});



// WEBPACK FOOTER //
// ./app/components/layout/recepcion/recepcionComponent.js